// extracted by mini-css-extract-plugin
export default {"NewsButtonContainer":"NewsButtonContainer_NewsButtonContainer__xKDco"};